import request from '@/utils/request'

export function getBookingGroupListApi(query) {
  return request({
    url: '/booking-service/v1/missions/list-by-booking-id',
    method: 'get',
    params: query
  })
}
